import classNames from "classnames";
import ToolTip from "components/design/toolTip";
import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { SortDown } from "components/icons/SortDown";
import { SortUp } from "components/icons/SortUp";
import {
  JESortColumnType,
  SORT_COLUMNS,
  SORT_ORDERS,
} from "constants/journalEntrySources";

export const JournalEntrySortDropdown = ({
  sorting,
  setSorting,
}: {
  sorting: { desc: boolean; id: JESortColumnType }[];
  setSorting: React.Dispatch<
    React.SetStateAction<{ desc: boolean; id: JESortColumnType }[]>
  >;
}) => {
  const currentSort = sorting[0];
  const sortByNewest = currentSort.desc;
  const sortTypeName = SORT_COLUMNS[currentSort.id].label;
  const sortOrderName = sortByNewest
    ? SORT_ORDERS.NEWEST.label
    : SORT_ORDERS.OLDEST.label;
  const tooltipText = `Sort by: ${sortTypeName} (${sortOrderName})`;

  const handleSortChange = (column: JESortColumnType, desc: boolean) => {
    setSorting([{ id: column, desc }]);
  };

  return (
    <Dropdown.Root>
      <ToolTip text={tooltipText} side="top">
        <span>
          <Dropdown.Trigger className="all:unset">
            <Button size="xsmall" customType="icon_primary_outlined">
              <span>{sortByNewest ? <SortUp /> : <SortDown />}</span>
            </Button>
          </Dropdown.Trigger>
        </span>
      </ToolTip>
      <Dropdown.Portal>
        <Dropdown.Content align="start" sideOffset={4}>
          {Object.values(SORT_COLUMNS).map((column) => (
            <Dropdown.Sub key={column.value}>
              <Dropdown.SubTrigger
                className={classNames(
                  "t-outline-none hover:t-outline-none focus-visible:t-outline-none",
                  {
                    "t-bg-purple-0": currentSort?.id === column.value,
                  }
                )}
              >
                {column.label}
              </Dropdown.SubTrigger>
              <Dropdown.Portal>
                <Dropdown.SubContent sideOffset={6}>
                  {Object.values(SORT_ORDERS).map((order) => (
                    <Dropdown.Item
                      key={order.label}
                      onSelect={() =>
                        handleSortChange(column.value, order.value)
                      }
                      className={classNames({
                        "t-bg-purple-0":
                          currentSort?.id === column.value &&
                          currentSort?.desc === order.value,
                      })}
                    >
                      {order.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.SubContent>
              </Dropdown.Portal>
            </Dropdown.Sub>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};
